import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from "./role.actions";
import * as fromGraphql from "./role.graphql";


@Injectable()
export class RoleEffects {
  createUserRole = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createUserRole),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_USER_ROLE,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          console.log(data)
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertRole({ role: result?.data })
              );
              this.notificationService.successMessage('Created Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateUserRole = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateUserRole),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_USER_ROLE,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertRole({ role: result?.data })
              );
              this.notificationService.successMessage('Updated Successfully');
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteUserRole = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deleteUserRole),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_USER_ROLE,
        variables: {
          roleUniqueId: action?.roleUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteRole({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getRoles = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getRoles),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_USER_ROLES,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching roles'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadRoles({ roles: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
